<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="数据类型：" prop="dataType">
            <el-select v-model="query.dataType" placeholder="请选择" clearable size="small">
              <el-option label="订单" :value="1"></el-option>
              <el-option label="充值" :value="2"></el-option>
              <el-option label="会议" :value="3"></el-option>
              <el-option label="升级身份" :value="4"></el-option>
              <el-option label="课程订单" :value="5"></el-option>
              <el-option label="售后补款" :value="7"></el-option>
              <el-option label="直播打赏" :value="8"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号：" prop="orderNumber">
            <el-input v-model="query.orderNumber" placeholder="请输入订单号" size="small" clearable />
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeState" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="已支付" name="1"></el-tab-pane>
          <el-tab-pane label="未支付" name="0"></el-tab-pane>        
          <el-tab-pane label="已退款" name="2"></el-tab-pane>
        </el-tabs>
      </div>
      <el-table v-loading="listLoading" :data="list" height="500">
        <el-table-column label="订单号" prop="orderNumber" align="center" fixed width="200" />
        <el-table-column label="数据类型" prop="dataType" align="center">
          <template slot-scope="{row}">
            {{getDataTypeName(row.dataType)}}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            {{getStateName(row.state)}}
          </template>
        </el-table-column>
        <el-table-column label="支付方式" prop="payMoney" align="center">
          <template slot-scope="{row}">
            {{ getPayTypeName(row.payType) }}
          </template>
          </el-table-column>
        <el-table-column label="支付城市公司" prop="cityCompanyName" align="center" fixed />
        <el-table-column label="支付商户号" prop="cusId" align="center" fixed />
        <el-table-column label="支付金额" prop="payMoney" align="center" />
        <el-table-column label="支付时间" prop="payTime" align="center" v-if="state!=0" />
        <el-table-column label="退款时间" prop="payTime" align="center" v-if="state===1" />
        <el-table-column label="创建时间" prop="createdTime" align="center" />
        <el-table-column label="请求参数" prop="payRequest" align="center" showToolTip="true" show-overflow-tooltip  />
        <!-- <el-table-column label="操作" align="center" fixed="right" width="160">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShowDetail(row)">查看详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import sysPayLogApi from '@/api/sys/sysPayLog'
import { filterEmpty } from '@/utils'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        dataType: null,
        orderNumber: null
      },
      activeState: '1'
    }
  },
  created() {
    // 从意向金管理「原支付订单」跳转过来时带订单号，直接按它查
    if (this.$route.query.orderNumber) this.query.orderNumber = String(this.$route.query.orderNumber)
    this.doQueryList({
      pageNo: 1
    })
  },
  methods: {
    getDataTypeName(type) {
      const typeMap = {
        1: '订单',
        2: '充值',
        3: '会议',
        4: '升级身份',
        5: '课程订单',
        7: '售后补款',
        8: '直播打赏'
      }
      return typeMap[type] || type
    },
    getStateName(state) {
      const stateMap = {
        0: '未支付',
        1: '已支付',
        2: '已退款'
      }
      return stateMap[state] || state
    },
    getPayTypeName(payType) {
     //1通联微信 2通联支付宝 3|通联银行卡 30|直连微信商户
     const paynameMap = {
        1: '通联微信',
        2: '通联支付宝',
        3: '通联银行卡',
        30: '直连微信商户'
      }
      return paynameMap[payType] || payType
    },

    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        dataType: null,
        orderNumber: null
      }
      this.activeState = ''
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    async doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        ...this.query,
        state: this.activeState ? parseInt(this.activeState) : 1
      }
      // 移除空值
      Object.keys(query).forEach(key => {
        if (query[key] === null || query[key] === undefined || query[key] === '') {
          delete query[key]
        }
      })

      this.listLoading = true
      try {
        const { data } = await sysPayLogApi.fetchList(filterEmpty(query))
        this.list = data.list || []
        this.total = data.total || 0
      } catch (error) {
        console.error('查询失败:', error)
        this.$message.error('查询失败')
      } finally {
        this.listLoading = false
      }
    },
    //查看信息
    handleShowDetail(row) {
      this.$emit('handleShow', { row, activeType: null }, 2)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>

